<template>
  <div class="s_bf2 box" :style="'margin:'+(data.style.paddingTB*0.9)+'px '+(data.style.paddingLR*0.9) +'px;'">
    <div class="heade" v-if='data.params.show'>
      <div class="headeTitle s_flex_center p-t-5">
        <img src="@/assets/images/integralShop/hot.png" alt=""><p class="fz-15 s_font_b m-l-5">{{data.params.goodTitle}}</p>
      </div>
    </div>
    <div class='goods' :class="data.style.class" v-if='data.data.length && data.params.rules == 3'>
      <div v-for="(item,index) in data.data" :key="index">
        <img style="object-fit:cover" :src="item.image?info.picdomain+item.image:require('@/assets/images/normal.png')" alt="">
        <div class="info">
          <p class="name">{{item.name}}</p>
          <div class='goodsPrice s_flex_bian_c width100'>
            <div class="s_flex_ali">
              <img style="width:13px; height:13px;margin-right: 3px;" src="@/assets/images/integralShop/jf.png" alt="">
              <span>{{item.point}}积分</span>
              <span v-if='item.price_type == 2'>+{{item.price}}元</span>
            </div>
            <img style="width:16px; height:13px" src="@/assets/images/integralShop/cart.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class='goods' :class="data.style.class" v-else>
      <div v-for="(item,index) in 4" :key="index">
        <img style="object-fit:cover" :src="require('@/assets/images/normal.png')" alt="">
        <div class="info">
          <p class="name">礼品名称</p>
          <div class='goodsPrice s_flex_bian_c width100'>
            <div class="s_flex_ali">
              <img style="width:13px; height:13px;margin-right: 3px;" src="@/assets/images/integralShop/jf.png" alt="">
              <span>100积分</span>
              <span>+1.00元</span>
            </div>
            <img style="width:16px; height:13px" src="@/assets/images/integralShop/cart.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import * as Icon from "@ant-design/icons-vue";
  import store from "@/store";
  export default {
    props: { data: Object },
    components: { ...Icon },
    name: "goods",
    setup(){
      return{
        info: store.state.user.info,
      }
    }
  }
</script>
<style lang="less" scoped>
  .box {
    border-radius: 10px;
  }

  .heade {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: #000;
    margin-bottom: 10px;

    .headeTitle {
      width: 100%;

      img {
        width: 25px;
        display: block;
      }
    }
    .headeRight {
      font-size: 12px;
    }
  }

  .goods {
    white-space: nowrap;
    max-width: 100%;
    >div {
      width: 100%;
      display: inline-block;
      font-size: 12px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      img {
        width: 88px;
        height: 88px;
        margin-right: 15px;
      }

      .name {
        margin-top: 5px;
        font-weight: 600;
        color: #000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 5px;
        font-size: 14px;
      }
      .goodsPrice {
        color: #F76B27;
        font-size: 12px;
      }
    }
  }
  .full{
    >div {
      background: #fff;
      border-radius: 5px;
      overflow: hidden;
      .info{
        width:70%;
        height: 88px;
        display: flex;
        align-content:space-between;
        flex-wrap: wrap;
        .name{
          width: 100%;
        }
        .goodsPrice{
          width:100%;
          padding-bottom: 8px;
        }
      }
    }
  }
  .whole{
    >div {
      background: #fff;
      border-radius: 5px;
      overflow: hidden;
      width:100%;
      flex-wrap: wrap;
      .info{
        width:100%;
        padding: 10px 10px 10px 10px;
      }
      img {
        width: 100%;
        height:250px;
        margin-right: 0;
      }
    }
  }
  .half {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    >div {
      width: 49%;
      background: #fff;
      flex-direction: column;
      border-radius: 5px;
      overflow: hidden;
      align-items: initial;
      padding-bottom: 10px;
      
      .info {
        padding: 0 7px;
      }

      img {
        width: 100%;
        height:150px;
        margin-right: 0;
      }
    }
  }
</style>